export default __webpack_public_path__ + "static/media/chr-busd.6285dfde.svg";